import { useQuery } from '@tanstack/react-query';

import axios from 'axios';

import { WallWindowRelations } from 'types';

export const getWalls = async (
  userId: number
): Promise<WallWindowRelations[]> => {
  const { data } = await axios.get(`/api/users/${userId}/walls`);
  return data as WallWindowRelations[];
};

export const useWalls = <T extends any = WallWindowRelations[]>(
  userId: number,
  select?: (data: WallWindowRelations[]) => T
) => {
  return useQuery({
    queryKey: ['walls'],
    queryFn: () => getWalls(userId),
    select: select,
  });
};
